import { listado } from "./listado";
import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    nombre: "",
    contacto: "",
    contactoCargo: "",
    logo: "",
    paisId: null,
    numeroOfertas: 0,
    unidadNegocioId: 0,
  };
}

export function listar(params) {
  return listado("clientes/listar", params);
}

export function cargar(id, conImagen = true) {
  return api.get("clientes/cargar&id=" + id + "&conImagen=" + conImagen).then((r) => r.data);
}

export function insertar({ cliente, imagenes, contactos }) {
  return api.post("clientes/insertar", { cliente, imagenes, contactos }).then((r) => r.data);
}

export function actualizar({ cliente, imagenes, contactos }) {
  return api.post("clientes/actualizar", { cliente, imagenes, contactos }).then((r) => r.data);
}

export function eliminar(id) {
  return api.post("clientes/eliminar", { id });
}

export function obtenerDivisa(id) {
  return api.post("clientes/obtenerDivisa", { id });
}

export function comprobarClienteCompleto(ofertaBaseId) {
  return api.post("clientes/comprobarClienteCompleto", { ofertaBaseId });
}
